export enum MapTypeEnum {
  STANDARD = 'STANDARD',
  EXTRA = 'EXTRA',
  MOBILE = 'MOBILE'
}
